/** Auth API client; failures surface as ``ApiError`` (branch on 401). */

import { apiFetch } from "@/lib/api/client"

import type { CurrentUser } from "./types"

/** Top-level navigation target of the "Sign in with Google" button. */
export const GOOGLE_START_URL = "/api/auth/google/start/"

const ME_URL = "/api/auth/me/"
const LOGOUT_URL = "/api/auth/logout/"

export function fetchCurrentUser(init?: RequestInit): Promise<CurrentUser> {
  return apiFetch<CurrentUser>(ME_URL, init)
}

/**
 * Terminate the Django session. Throws ``ApiError`` on non-2xx; treat a
 * 401 as "already signed out".
 */
export function signOut(init?: RequestInit): Promise<void> {
  return apiFetch<void>(LOGOUT_URL, { ...init, method: "POST" })
}
